import { defineMessages } from 'react-intl';

export { default as ENTRY } from './entry';

export const PATH = '/';
export const pageName = 'Home';
export const HOME_GA_CATEGORY = 'Homepage';
export const HOME_PAGE_KEY = '@@HomePage';

export const ActionTypes = {
    TRACK_PAGEHEADER_LOGO_CLICK: `${HOME_PAGE_KEY}/TRACK_PAGEHEADER_LOGO_CLICK`,
    TRACK_PAGEHEADER_CTALINK_CLICK: `${HOME_PAGE_KEY}/TRACK_PAGEHEADER_CTALINK_CLICK`,
    TRACK_PAGE_FOOTER_LINK_CLICK: `${HOME_PAGE_KEY}/TRACK_PAGE_FOOTER_LINK_CLICK`,
    TRACK_TEXT_ME_THE_APP_BUTTON_CLICK: `${HOME_PAGE_KEY}/TRACK_TEXT_ME_THE_APP_BUTTON_CLICK`,
    TRACK_FIND_A_DOCTOR_BY_LINK_CLICK: `${HOME_PAGE_KEY}/TRACK_FIND_A_DOCTOR_BY_LINK_CLICK`,
    TRACK_MOBILE_MENU_LINK_CLICK: `${HOME_PAGE_KEY}/TRACK_MOBILE_MENU_LINK_CLICK`,
    TRACK_KNOWLEDGE_BASE_CLICK: `${HOME_PAGE_KEY}/TRACK_KNOWLEDGE_BASE_CLICK`,
    TRACK_LIST_PRACTICE_BUTTON_CLICK: `${HOME_PAGE_KEY}/TRACK_LIST_PRACTICE_BUTTON_CLICK`,
    TRACK_CHECK_OUR_CAREERS_PAGE: `${HOME_PAGE_KEY}/TRACK_CHECK_OUR_CAREERS_PAGE`,
    TRACK_JOIN_PARTNERS_BUTTON_CLICK: `${HOME_PAGE_KEY}/TRACK_JOIN_PARTNERS_BUTTON_CLICK`,
};

export const LOCALIZED_STRINGS = defineMessages({
    FEELING_MEH_LINE_1: {
        id: 'Home.Headline.FeelingMehLine1',
        defaultMessage: 'Feeling meh?',
    },
    FEELING_MEH_LINE_2: {
        id: 'Home.Headline.FeelingMehLine2',
        defaultMessage: 'Find a doctor.',
    },
    FEELING_MEH_FREE_LINE_1: {
        id: 'Home.Headline.FeelingMehFreeLine1',
        defaultMessage: 'Feeling meh?',
    },
    FEELING_MEH_FREE_LINE_2: {
        id: 'Home.Headline.FeelingMehFreeLine2',
        defaultMessage: 'Find a doctor.',
    },
    FEELING_MEH_FREE_LINE_3: {
        id: 'Home.Headline.FeelingMehFreeLine3',
        defaultMessage: ' It\'s free.',
    },
    RIGHT_DOCTOR_RIGHT_NOW_LINE_1: {
        id: 'Home.Headline.RightDoctorRightNowLine1',
        defaultMessage: 'Right doctor.',
    },
    RIGHT_DOCTOR_RIGHT_NOW_LINE_2: {
        id: 'Home.Headline.RightDoctorRightNowLine2',
        defaultMessage: 'Right now. It\'s free.',
    },
    THEMED_SEARCH_PHYSICAL_TAGLINE: {
        id: 'Home.ThemedSearch.PhysicalTagline',
        defaultMessage: 'Been putting off that physical?',
    },
    THEMED_SEARCH_PHYSICAL_CTA: {
        id: 'Home.ThemedSearch.PhysicalCta',
        defaultMessage: 'Book it now, free',
    },
    THEMED_SEARCH_THERAPIST_TAGLINE: {
        id: 'Home.ThemedSearch.TherapistTagline',
        defaultMessage: 'You\'re not alone.',
    },
    THEMED_SEARCH_THERAPIST_CTA: {
        id: 'Home.ThemedSearch.TherapistCta',
        defaultMessage: 'Speak to a therapist',
    },
    THEMED_SEARCH_ALLERGIST_TAGLINE: {
        id: 'Home.ThemedSearch.AllergistTagline',
        defaultMessage: 'Feeling low when the pollen count is high?',
    },
    THEMED_SEARCH_ALLERGIST_CTA: {
        id: 'Home.ThemedSearch.AllergistCta',
        defaultMessage: 'Find an allergist',
    },
    THEMED_SEARCH_FLU_SHOT_TAGLINE: {
        id: 'Home.ThemedSearch.FluShotTagline',
        defaultMessage: 'Get the shot, not the flu.',
    },
    THEMED_SEARCH_FLU_SHOT_CTA: {
        id: 'Home.ThemedSearch.FluShotCta',
        defaultMessage: 'Book a flu shot',
    },
});
